import { useEffect, useState } from 'react';
import { ContentfulLivePreview } from '@contentful/live-preview';
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import resolvedData from 'contentful/ResolveContentfulResponse';

const useContentfulPreview = entry => {
  const [resolvedEntry, setResolvedEntry] = useState(entry);

  useEffect(() => {
    ContentfulLivePreview.init({
      locale: 'en-US',
      enableLiveUpdates: true,
    });
  });

  useEffect(() => {
    const resolved = resolvedData(entry);
    setResolvedEntry(resolved);
  }, [entry]);

  const data = useContentfulLiveUpdates(resolvedEntry);

  const parsedData = typeof data === 'string' ? resolvedData(data) : data;

  return { ...parsedData[0] };
};

export default useContentfulPreview;
